export default __webpack_public_path__ + "static/media/qualitativeAssessmentMethodology.71cb162c.pdf";